import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text } from '@pancakeswap/uikit'
import { Progman21 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'

const InfluencersModal = ({ close, modalStyle, frameStyle, bulletStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Progman21 />}
      title="Influencers"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Influencers`)}
        </Heading>

        <Text fontSize="18px">
          {t(
            `Strategic partnerships with crypto influencers are a critical part of the growth of new tokens. Just like with V1, we intend to be actively engaged with with prominent partners in the space, including:`,
          )}
        </Text>
        <ul>
          <li style={bulletStyle}>{t(`Caesar's Calls, voice AMA scheduled for the week of November 15th`)}</li>
          <li style={bulletStyle}>
            {t(`CryptoKorea, pinned tweet to 40k followers, pinned in Telegrams with 100k total members`)}
          </li>
          <li style={bulletStyle}>{t(`JapaneseCrypto`)}</li>
          <li style={bulletStyle}>{t(`CryptoProfessor`)}</li>
        </ul>

        <Text fontSize="18px">{t(`Next up on our influencer roadmap we're targeting:`)}</Text>

        <ul>
          <li style={bulletStyle}>{t(`SatoshiStreetBets, voice AMA in their Telegram`)}</li>
        </ul>

        <a href="https://t.me/windoge95char" target="_blank" rel="noreferrer">
          <Text fontSize="24px" fontWeight="bold" color="#000088">
            <u>{t(`Join Our Telegram`)}</u>
          </Text>
        </a>
      </Frame>
    </Modal>
  )
}

export default InfluencersModal
